import { render } from "./Activate.vue?vue&type=template&id=30dd6c36"
import script from "./Activate.vue?vue&type=script&lang=js"
export * from "./Activate.vue?vue&type=script&lang=js"

import "./Activate.vue?vue&type=style&index=0&id=30dd6c36&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__